import TbnSpinner from './TbnSpinner'

const TelSpinner = () => {
  return <TbnSpinner />
}

export default TelSpinner
